/**
 * @desc Force money containing string into a sensible shape: only one , or . is allowed as a delimiter. No separator, no chars, no -, no bs
 */
export default function sanitizeMoney(value: string, precision = 2) {
  return value
    .replace(/[^\d.,]/g, '') // drop anything except digits, dots and commas
    .replace(/^([.,]{1,1})/, '0$1') // insert a zero before any leading coma or dot
    .replace(/^0{2,}/, '0') // limit to one leading 0
    .replace(/^0([\d]+)([\d,.]*)/, '$1$2') // drop leading zero if another digit is already provided
    .replace(/[.,]([^.,]*)(?=[.,])/g, '$1') // drop any dots and commas except the last one
    .replace(new RegExp(`([.,]\\d{${precision}}).*$`), '$1') // limit to two decimal places
}
